import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    constructor(private http: HttpClient) {}

    log(message: any) {
        const logData = {
            message: message
        };
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        this.http.post('/ocsp-web-ui/log', logData, httpOptions).subscribe({
          next: (response) => {
              console.log('Log sent successfully', response);
          },
          error: (error) => {
              console.error('Error sending log', error);
          },
          complete: () => {}
    });
    }
}
